import React from 'react';
import './contactConfirmation.css';
import Checkmark from '../images/checkmark.png'; 

function ContactConfirmation() {
    return (
        <div className="confirmation-page">
            <div className='confirmation-card'>
                <h1>Message Sent!</h1>
                <img src={Checkmark} alt="Checkmark" className="checkmark" />
                <p>Thanks for reaching out. <br></br> We'll get back to you as soon as possible.</p>
            </div>
        </div>
    );
}

export default ContactConfirmation;